/**
 * 证书路由模块
 * 包含证书查询页面
 */

const children = [
  {
    path: 'query',
    name: 'certificate_query',
    url: '/certificate/query',
    meta: { title: '证书查询', requiresAuth: false },
    component: () => import(/* webpackChunkName: "certificate" */ '@/views/certificate/query.vue')
  }
];

export default {
  path: '/certificate',
  name: 'certificate',
  meta: { title: '证书查询' },
  component: () => import('@/layout/user.vue'),
  children: children
};
